<div class="mb-54 mct-flex mct-row mct-justify-between mct-items-center"  >
  <span class="title-header">{{ 'web-content.manage-web-content.header' | translate | titlecase }}</span>
  <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="isReadOnly" (click)="editDialog.showModal()" data-cy="btnNewWebContent">
    {{ 'web-content.manage-web-content.new-web-content' | translate | uppercase }}
  </button>
</div>

<wl-web-content-edit-dialog #editDialog (webContentSaved)="search()"></wl-web-content-edit-dialog>

<wl-web-content-search-params [(searchParams)]="webContentSearchParams"></wl-web-content-search-params>

<div class="mv-27 mct-flex mct-row mct-justify-end mct-items-center mct-gap-10"   >
  <button pButton type="button"   class="atlas-btn atlas-btn-secondary mct-flex mct-row mct-justify-center mct-items-center" (click)="clear()">
    <i class="pi pi-times"></i>
    {{ 'web-content.manage-web-content.clear-search' | translate | uppercase }}
  </button>
  <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="search()" data-cy="btnWebContentSearch">
    {{ 'web-content.manage-web-content.run-this-search' | translate | uppercase }}
  </button>
</div>

<wl-web-content-search-grid [isReadOnly]= "isReadOnly" [searchParams]="webContentSearchParams"></wl-web-content-search-grid>
